import React from 'react';
import { motion } from 'framer-motion';
import { Users, Building2, HeartHandshake } from 'lucide-react';
import { fadeUp, staggerParent, scaleIn, viewportOnce } from './motionPresets';

const TEAM_IMG = 'https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&w=1000&q=80';
const OFFICE_IMG = 'https://images.unsplash.com/photo-1739298061740-5ed03045b280?crop=entropy&cs=srgb&fm=jpg&w=800&q=80';
const MEETING_IMG = 'https://images.unsplash.com/photo-1780733064275-d1ade9b83a3d?crop=entropy&cs=srgb&fm=jpg&w=800&q=80';

export default function TrustSection() {
  return (
    <section className="bg-[#f8fafc] py-20 sm:py-28 lg:py-32" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce} className="lg:col-span-5">
          <motion.span variants={fadeUp} className="text-xs font-semibold uppercase tracking-widest text-[#b8862d]">Real people behind KR</motion.span>
          <motion.h2 variants={fadeUp} className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">A team invested in your growth.</motion.h2>
          <motion.p variants={fadeUp} className="mt-5 text-lg text-slate-600 leading-relaxed">
            KR is built by people who understand the business. From contracting specialists to trainers and back-office
            support, there's a real organization standing behind every agent.
          </motion.p>
          <motion.div variants={staggerParent} className="mt-8 space-y-4">
            {[
              { icon: HeartHandshake, t: 'Dedicated support', d: 'Real staff you can reach — not a ticket black hole.' },
              { icon: Building2, t: 'Established infrastructure', d: 'Technology, operations, and processes built for scale.' },
              { icon: Users, t: 'A growing community', d: 'Agents, producers, and agencies growing side by side.' },
            ].map((r) => (
              <motion.div key={r.t} variants={fadeUp} className="flex gap-4">
                <span className="w-11 h-11 rounded-xl bg-[#0f2a5e] text-[#f5c876] flex items-center justify-center shrink-0"><r.icon size={19} /></span>
                <div>
                  <div className="text-base font-bold text-slate-900">{r.t}</div>
                  <div className="text-sm text-slate-600">{r.d}</div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>

        <motion.div variants={scaleIn} initial="hidden" whileInView="show" viewport={viewportOnce} className="lg:col-span-7">
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2 rounded-2xl overflow-hidden shadow-xl">
              <img src={TEAM_IMG} alt="KR leadership and team" loading="lazy" className="w-full aspect-[16/9] object-cover" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img src={OFFICE_IMG} alt="KR office environment" loading="lazy" className="w-full aspect-[4/3] object-cover" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img src={MEETING_IMG} alt="KR agent consultation" loading="lazy" className="w-full aspect-[4/3] object-cover" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
